/** Admin-only operations (`/admin`). */
import { apiClient } from "../lib/apiClient";

/**
 * Download a full database backup as a JSON file. Uses the shared axios client
 * (so the auth token is attached) and streams the response into a file the
 * browser saves locally.
 */
export async function downloadDatabaseBackup(): Promise<void> {
  const res = await apiClient.get("/admin/backup", { responseType: "blob" });

  const disposition = res.headers["content-disposition"] as string | undefined;
  const match = disposition?.match(/filename="?([^"]+)"?/);
  const filename = match?.[1] ?? `factory-mis-backup-${new Date().toISOString().slice(0, 10)}.json`;

  const blob = res.data as Blob;
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
